import { defineMessages } from 'react-intl';

export default defineMessages({
    viewInvoices: {
        id: 'ent.billing.billing-summary.View Invoices',
        defaultMessage: 'View Invoices',
    },
    viewInvoicesWithAutoPayEnabled: {
        id: 'ent.billing.billing-summary.View Invoices (Auto Pay Enabled)',
        defaultMessage: 'View Invoices (Auto Pay Enabled)',
    },
    makeAPayment: {
        id: 'ent.billing.billing-summary.Make a Payment',
        defaultMessage: 'Make a Payment',
    },
    viewPolicies: {
        id: 'ent.billing.billing-summary.View Policies',
        defaultMessage: 'View Policies',
    },
    changePaymentMethod: {
        id: 'ent.billing.billing-summary.Edit Automatic Payments',
        defaultMessage: 'Edit Auto Pay',
    },
    setupAutomaticPayments: {
        id: 'ent.billing.billing-summary.Setup Automatic Payments',
        defaultMessage: 'Setup Automatic Payments',
    },
    setupAutoPay: {
        id: 'billing.billing-summary.Setup Auto Pay',
        defaultMessage: 'Setup Auto Pay',
    },
    editAutoPay: {
        id: 'billing.billing-summary.Edit Auto Pay',
        defaultMessage: 'Edit Auto Pay',
    },
    selectInvoicesToPay: {
        id: 'ent.billing.billing-summary.Select Invoices to Pay',
        defaultMessage: 'Select Invoices to Pay',
    },
    selectInvoicesToPayWithAutoPayEnabled: {
        id: 'ent.billing.billing-summary.Select Invoices to Pay (Auto Pay Enabled)',
        defaultMessage: 'Select Invoices to Pay (Auto Pay Enabled)',
    },
    policies: {
        id: 'ent.billing.billing-summary.Policies',
        defaultMessage: 'Policies',
    },
    payNow: {
        id: 'ent.billing.billing-summary.Pay Now',
        defaultMessage: 'Pay Now',
    },
    homeownersPolicyAutomaticPaymentsEnabled: {
        id: 'ent.billing.billing-summary.Homeowners Policy (Automatic Payments Enabled)',
        defaultMessage: 'Homeowners Policy (Automatic Payments Enabled)',
    },
    homeownersPolicy: {
        id: 'ent.billing.billing-summary.Homeowners Policy',
        defaultMessage: 'Homeowners Policy',
    },
    commercialPropertyPolicyAutomaticPaymentsEnabled: {
        id: 'ent.billing.billing-summary.Commercial Property Policy (Automatic Payments Enabled)',
        defaultMessage:
            'Commercial Property Policy (Automatic Payments Enabled)',
    },
    commercialPropertyPolicy: {
        id: 'ent.billing.billing-summary.Commercial Property Policy',
        defaultMessage: 'Commercial Property Policy',
    },
    policyAutomaticPaymentsEnabled: {
        id: 'ent.billing.billing-summary.Policy (Automatic Payments Enabled)',
        defaultMessage: 'Policy (Automatic Payments Enabled)',
    },
    policy: {
        id: 'ent.billing.billing-summary.Policy',
        defaultMessage: 'Policy',
    },
    ok: {
        id: 'ent.billing.billing-summary.OK',
        defaultMessage: 'OK',
    },
    invoicesAutomaticPaymentsEnabled: {
        id: 'ent.billing.billing-summary.Invoices (Automatic Payments Enabled)',
        defaultMessage: 'Invoices (Automatic Payments Enabled)',
    },
    paymentSchedule: {
        id: 'ent.billing.billing-summary.Payment Schedule',
        defaultMessage: 'Payment Schedule',
    },
    startingDate: {
        id: 'ent.billing.billing-summary.Starting Date',
        defaultMessage: 'Starting Date',
    },
    paymentMethodHasBeenChanged: {
        id: 'ent.billing.billing-summary.Payment method has been changed.',
        defaultMessage: 'Payment method has been changed.',
    },
    automaticPaymentOfHasBeenAppliedToYourAccount: {
        id: 'ent.billing.billing-summary.Your payment method has been successfully updated to automatic renewal.',
        defaultMessage:
            'Your payment method has been successfully updated to automatic renewal.',
    },
    yourAutomaticPaymentsWillBeginOn: {
        id: 'ent.billing.billing-summary.Your automatic payments will begin on x.',
        defaultMessage: 'Your automatic payments will begin on {startingDate}.',
    },
    paymentOfHasBeenAppliedToYourAccount: {
        id: 'ent.billing.billing-summary.Payment of x has been applied to your account.',
        defaultMessage:
            'Payment of {paidAmount} has been applied to your account.',
    },
    amountToPay: {
        id: 'ent.billing.billing-summary.Amount to Pay',
        defaultMessage: 'Amount to Pay',
    },
    paymentRequestFailed: {
        id: 'ent.billing.billing-summary.Payment request failed',
        defaultMessage: 'Payment request failed',
    },
    sorryYourPaymentCouldNotBeProcessedAtThisTime: {
        id: 'ent.billing.billing-summary.Sorry your payment could not be processed at this time',
        defaultMessage:
            'Sorry your payment could not be processed at this time',
    },
    accountUpdateFailed: {
        id: 'ent.billing.billing-summary.Account update failed',
        defaultMessage: 'Account update failed',
    },
    sorryWeWereNotAbleToSetupAutomaticPaymentsOnYourAccount: {
        id: 'ent.billing.billing-summary.Sorry, we were not able to setup automatic payments on your account',
        defaultMessage:
            'Sorry, we were not able to setup automatic payments on your account',
    },
    changingPaymentMethod: {
        id: 'ent.billing.billing-summary.Changing payment method',
        defaultMessage: 'Changing payment method',
    },
    thereWasAProblemChangingThePaymentMethod: {
        id: 'ent.billing.billing-summary.There was a problem changing the payment method',
        defaultMessage: 'There was a problem changing the payment method',
    },
    invoicesToPay: {
        id: 'ent.billing.billing-summary.Invoices to Pay',
        defaultMessage: 'Invoices to Pay',
    },
    paidInvoices: {
        id: 'ent.billing.billing-summary.Paid Invoices',
        defaultMessage: 'Paid Invoices',
    },
    policyPeriodAll:{
        id: 'billing.payment-center-page.PolicyPeriod.All',
        defaultMessage: 'All',
    },    
    paymentPlan:{
        id: 'billing.payment-center-page.PolicyPeriod.Payment Plan',
        defaultMessage: 'Payment Plan:',
    },
    policyPeriod:{
        id: 'billing.payment-center-page.Policy Period:',
        defaultMessage: 'Policy Period:',
    },         
    current:{
        id: 'billing.payment-center-page.(Current)',
        defaultMessage: '(Current)',
    },
    validationMessageIfPaymentisMore: {
        id: 'billing.payment-center-page.Payment amount cannot be more than the sum of the selected invoices.',
        defaultMessage: 'Payment amount cannot be more than the sum of the selected invoices.',
    },
    validationMessagegIfPaymentIsLess: {
        id: 'billing.payment-center-page.Please pay the minimum balance for all past due invoices',
        defaultMessage: 'Please pay the minimum balance for all past due invoices.',
    }
});
